import { createContext, useContext, type ReactNode } from "react";

const DtoolsPdfPackageContext = createContext(false);

export function DtoolsPdfPackageProvider({ children }: { children: ReactNode }) {
  return <DtoolsPdfPackageContext.Provider value={true}>{children}</DtoolsPdfPackageContext.Provider>;
}

export function useDtoolsPdfPackageMode(): boolean {
  return useContext(DtoolsPdfPackageContext);
}
